export default __webpack_public_path__ + "static/media/copy-dark.d847f8e6.svg";